export default {"src":"/_next/static/media/student-wrok-at-company.85c87926.svg","height":324,"width":990,"blurWidth":0,"blurHeight":0};